import { render, staticRenderFns } from "./MessagesDraftView.vue?vue&type=template&id=730f1f09&scoped=true"
import script from "./MessagesDraftView.vue?vue&type=script&lang=js"
export * from "./MessagesDraftView.vue?vue&type=script&lang=js"
import style0 from "./MessagesDraftView.vue?vue&type=style&index=0&id=730f1f09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730f1f09",
  null
  
)

export default component.exports